// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"f5f3104a","810":"32f26db2"}[chunkId] + ".chunk.css";
};